import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { endOfDay, endOfMonth, endOfWeek, endOfYear, format, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subWeeks, } from "date-fns";
import { clampDateString, clampTimeString } from "../../../utils/functions";
import { Input } from "../../Input";
import { DateHourInput, InputsArea, OptionsList } from "./styles";
import { useEffect, useState } from "react";
var INPUT_HEIGHT = 28;
var DATE_WIDTH = 105;
var TIME_WIDTH = 60;
export var CalendarInputs = function (_a) {
    var selectedDate = _a.selectedDate, setHoveredDays = _a.setHoveredDays, setSelectedDate = _a.setSelectedDate;
    return (_jsxs(InputsArea, { children: [_jsxs(DateHourInput, { children: [_jsx("span", { children: "De" }), _jsx(DateInput, { value: selectedDate.start, type: "start", compareDate: selectedDate.end, setValue: function (e) {
                            setHoveredDays([]);
                            setSelectedDate({
                                start: e,
                                end: selectedDate.end,
                            });
                        } }), _jsx(TimeInput, { value: selectedDate.start, type: "start", compareDate: selectedDate.end, setValue: function (e) {
                            setHoveredDays([]);
                            setSelectedDate({
                                start: e,
                                end: selectedDate.end,
                            });
                        } })] }), _jsxs(DateHourInput, { children: [_jsx("span", { children: "At\u00E9" }), _jsx(DateInput, { value: selectedDate.end, type: "end", compareDate: selectedDate.start, setValue: function (e) {
                            setHoveredDays([]);
                            setSelectedDate({
                                start: selectedDate.start,
                                end: e,
                            });
                        } }), _jsx(TimeInput, { value: selectedDate.end, type: "end", compareDate: selectedDate.start, setValue: function (e) {
                            setHoveredDays([]);
                            setSelectedDate({
                                start: selectedDate.start,
                                end: e,
                            });
                        } })] })] }));
};
export var OPTIONS_FUNCTIONS = {
    Hoje: function () { return ({
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
    }); },
    Ontem: function () {
        var yesterday = subDays(new Date(), 1);
        return {
            start: startOfDay(yesterday),
            end: endOfDay(yesterday),
        };
    },
    "Essa semana": function () { return ({
        start: startOfWeek(new Date()),
        end: endOfWeek(new Date()),
    }); },
    "Semana passada": function () {
        var lastWeek = subWeeks(new Date(), 1);
        return {
            start: startOfWeek(lastWeek),
            end: endOfWeek(lastWeek),
        };
    },
    "Esse mês": function () { return ({
        start: startOfMonth(new Date()),
        end: endOfMonth(new Date()),
    }); },
    "Mês passado": function () {
        var lastMonth = subMonths(new Date(), 1);
        return {
            start: startOfMonth(lastMonth),
            end: endOfMonth(lastMonth),
        };
    },
    "Esse ano": function () { return ({
        start: startOfYear(new Date()),
        end: endOfYear(new Date()),
    }); },
};
export var CalendarOptions = function (_a) {
    var hideOptions = _a.hideOptions, setSelectedDate = _a.setSelectedDate, handleSelectDate = _a.handleSelectDate;
    return (_jsx(OptionsList, { children: Object.keys(OPTIONS_FUNCTIONS)
            .filter(function (option) {
            return !hideOptions.includes(option);
        })
            .map(function (option) {
            return (_jsx("li", { onClick: function () {
                    // setHoveredDays([]);
                    setSelectedDate(OPTIONS_FUNCTIONS[option]());
                    handleSelectDate(OPTIONS_FUNCTIONS[option]());
                }, children: option }, option));
        }) }));
};
export var TimeInput = function (_a) {
    var value = _a.value, setValue = _a.setValue, _b = _a.type, type = _b === void 0 ? "start" : _b, compareDate = _a.compareDate;
    var _c = useState(format(value, "HH:mm")), timeValue = _c[0], setTimeValue = _c[1];
    useEffect(function () {
        setTimeValue(format(value, "HH:mm"));
    }, [value]);
    var handleBlur = function () {
        var clampedDate = clampTimeString(timeValue, value, type, compareDate);
        if (isNaN(clampedDate.getTime())) {
            setTimeValue(format(value, "HH:mm"));
            return;
        }
        setValue(clampedDate);
    };
    return (_jsx(Input, { mask: "99:99", value: timeValue, onFocus: function () {
            setTimeValue("");
        }, onChange: function (e) {
            setTimeValue(e.target.value);
        }, onBlur: handleBlur, style: {
            width: TIME_WIDTH,
            height: INPUT_HEIGHT,
            padding: "4px 8px",
            textAlign: "center",
        } }));
};
export var DateInput = function (_a) {
    var value = _a.value, setValue = _a.setValue, _b = _a.type, type = _b === void 0 ? "start" : _b, compareDate = _a.compareDate;
    var _c = useState(format(new Date(value), "dd/MM/yyyy")), dateValue = _c[0], setDateValue = _c[1];
    useEffect(function () {
        setDateValue(format(value, "dd/MM/yyyy"));
    }, [value]);
    var handleBlur = function () {
        var clampedDate = clampDateString(dateValue, value, type, compareDate);
        if (isNaN(clampedDate.getTime())) {
            setDateValue(format(value, "dd/MM/yyyy"));
            return;
        }
        setValue(clampedDate);
    };
    return (_jsx(Input, { mask: "99/99/9999", value: dateValue, onFocus: function () {
            setDateValue("");
        }, onBlur: handleBlur, onChange: function (e) {
            setDateValue(e.target.value);
        }, style: {
            width: DATE_WIDTH,
            height: INPUT_HEIGHT,
            padding: "4px 8px",
            textAlign: "center",
        } }));
};
//# sourceMappingURL=index.js.map